var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkAlt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.08945 4.1748C1.91043 4.1748 1.73874 4.24592 1.61216 4.37251C1.48557 4.49909 1.41445 4.67078 1.41445 4.8498V12.2748C1.41445 12.4538 1.48557 12.6255 1.61216 12.7521C1.73874 12.8787 1.91043 12.9498 2.08945 12.9498H9.51445C9.69347 12.9498 9.86516 12.8787 9.99175 12.7521C10.1183 12.6255 10.1895 12.4538 10.1895 12.2748V8.2248C10.1895 7.85201 10.4917 7.5498 10.8645 7.5498C11.2372 7.5498 11.5395 7.85201 11.5395 8.2248V12.2748C11.5395 12.8119 11.3261 13.3269 10.9463 13.7067C10.5666 14.0865 10.0515 14.2998 9.51445 14.2998H2.08945C1.55239 14.2998 1.03732 14.0865 0.657562 13.7067C0.277801 13.3269 0.0644531 12.8119 0.0644531 12.2748V4.8498C0.0644531 4.31274 0.277801 3.79767 0.657562 3.41791C1.03732 3.03815 1.55239 2.8248 2.08945 2.8248H6.13945C6.51225 2.8248 6.81445 3.12701 6.81445 3.4998C6.81445 3.8726 6.51225 4.1748 6.13945 4.1748H2.08945Z",
    fill: "#4288F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.16445 1.4748C8.16445 1.10201 8.46666 0.799805 8.83945 0.799805H12.8895C13.2622 0.799805 13.5645 1.10201 13.5645 1.4748V5.5248C13.5645 5.8976 13.2622 6.1998 12.8895 6.1998C12.5167 6.1998 12.2145 5.8976 12.2145 5.5248V2.1498H8.83945C8.46666 2.1498 8.16445 1.8476 8.16445 1.4748Z",
    fill: "#4288F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3668 0.997508C13.6304 1.26111 13.6304 1.6885 13.3668 1.9521L5.94175 9.3771C5.67815 9.64071 5.25076 9.64071 4.98716 9.3771C4.72355 9.1135 4.72355 8.68611 4.98716 8.42251L12.4122 0.997508C12.6758 0.733904 13.1031 0.733904 13.3668 0.997508Z",
    fill: "#4288F2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkAlt);
export default __webpack_public_path__ + "static/media/link-alt.f5603fa9288c039d4174a3817b60bfa6.svg";
export { ForwardRef as ReactComponent };